import createVueComponent from '../createVueComponent';

const SendHorizontal = createVueComponent('SendHorizontalIcon', [
  ['path', { d: 'm3 3 3 9-3 9 19-9Z', key: '1aobqy' }],
  ['path', { d: 'M6 12h16', key: 's4cdu5' }],
]);

export default SendHorizontal;
